import { createSelector, createSlice } from '@reduxjs/toolkit';

type interiorSliceType = {
  carHotSpotCardStatus: number;
  pitch: number;
  yaw: number;
};

const initialState: interiorSliceType = {
  carHotSpotCardStatus: 1,
  pitch: 0, // move in y -180,180
  yaw: 0, // move in x -180,180
};

const interiorSlice = createSlice({
  initialState,
  name: 'interior',
  reducers: {
    carHotSpotCardStatusSet: (state, { payload }) => {
      state.carHotSpotCardStatus = payload;
    },

    pitchSet: (state, { payload }) => {
      state.pitch = payload;
    },
    yawSet: (state, { payload }) => {
      state.yaw = payload;
    },
  },
});

export const getPitch = createSelector(
  (state: { interior: interiorSliceType }) => state.interior,
  (interior) => interior.pitch,
);

export const getYaw = createSelector(
  (state: { interior: interiorSliceType }) => state.interior,
  (interior) => interior.yaw,
);

export const getCarHotSpotCardStatus = createSelector(
  (state: { interior: interiorSliceType }) => state.interior,
  (interior) => interior.carHotSpotCardStatus,
);

export default interiorSlice.reducer;

export const { carHotSpotCardStatusSet, yawSet, pitchSet } =
  interiorSlice.actions;
